import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TrophyFilledSvg from "@ant-design/icons-svg/es/asn/TrophyFilled";
import AntdIcon from "../components/AntdIcon";
var TrophyFilled = function TrophyFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TrophyFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TrophyFilled.displayName = 'TrophyFilled';
}
export default /*#__PURE__*/React.forwardRef(TrophyFilled);